/**
 * @ngdoc function
 * @name lmApp.controller:VodController
 * @description
 * # VodController
 * Controller of the lmApp
 */

lmApp
  .controller('VodController', ['$routeParams', '$location', '$q', '$scope', '$templateCache', '$compile', '$rootScope', '$timeout', '$interval', 'AssetService', 'MetadataService', 'ModalWindowService', 'ToastService', 'ValidatorService', 'ModalConfirmService', 'ImportService', 'AssetResource', 'TimezoneService', 'ManagerResource', 'GenreResource', 'CategoryResource', 'SubscriberResource', 'SubscriberV2Service', 'AssetV2Service',
    function ($routeParams, $location, $q, $scope, $templateCache, $compile, $rootScope, $timeout, $interval, AssetService, MetadataService, ModalWindowService, ToastService, ValidatorService, ModalConfirmService, ImportService, AssetResource, TimezoneService, ManagerResource, GenreResource, CategoryResource, SubscriberResource, SubscriberV2Service, AssetV2Service) {
      // Timezone
      var timezone = _.find(TimezoneService.Timezones, {title: 'UTC'});
      $scope.tz = timezone.title;
      ManagerResource.get().$promise
          .then(function (result) {
            if (result.length !== 0) {
              var manager = _.find(result, {username: $rootScope.globals.currentUser.username});
              if (manager) {
                timezone = _.find(TimezoneService.Timezones, {title: manager.ui_timezone || 'UTC'});
                $scope.tz = timezone.title;
              }
            }
          })
          .catch(function (reason) {
            $rootScope.debugInfo(reason, 'silent');
          });

      $scope.convertTime = function (dt) {
        return TimezoneService.addTimezoneToDate(dt, timezone)
      };

      /////////////
      $scope.assets = [];
      $scope.limit = 20;
      $scope.offset = 0;
      $scope.total = 0;
      $scope.categories = [];
      $scope.genres = [];
      $scope.packages = [];

      $scope.filters = {
        name: '',
        type: {
          movie: true,
          series: true,
          episode: false
        },
        categories: [],
        genres: [],
        packages: []
      };
      ///
        $scope.findSubscriberLoading = false;
        $scope.subscribers = []
        $scope.selectedSubscriber = {}
        $scope.selectedResource = {
            id: 0,
            loading: false,
            url: '',
            urlEsc: '',
            error: '',
            subscriber: {},
            wvLicenseURL: '',
            fpsLicenseURL: '',
            fpsCertURL: '',
            type: '',
        }
      //

      var getFilterData = function () {
          GenreResource.get().$promise
              .then(function (genres) {
                  var genreList = [];
                  for (var i = 0; i < genres.length; i++) {
                      var genre = genres[i];
                      genreList.push({
                          id: genre.id,
                          title: genre.name
                      });
                  }
                  $scope.genres = genreList;
              })
              .catch(function (reason) {
                  $rootScope.debugInfo(reason);
              });

          CategoryResource.get().$promise
              .then(function (categories) {
                  var categoryList = [];
                  for (var i = 0; i < categories.length; i++) {
                      var category = categories[i];
                      categoryList.push({
                          id: category.id,
                          title: category.name
                      });
                  }
                  $scope.categories = categoryList;
              })
              .catch(function (reason) {
                  $rootScope.debugInfo(reason);
              });

          AssetResource.get({'type[in]': 'package'}).$promise
              .then(function (packages) {
                  var packageList = [];
                  for (var i = 0; i < packages.length; i++) {
                      var p = packages[i];
                      packageList.push({
                          id: p.id,
                          title: p.name
                      });
                  }
                  $scope.packages = packageList;
              })
              .catch(function (reason) {
                  $rootScope.debugInfo(reason);
              });
      };

      getFilterData();

      var processAsset = function(asset) {
        var processed = {
          id: asset.id,
          extid: asset.ext_id,
          createTime: asset.create_time,
          updateTime: asset.update_time,
          status: asset.status,
          type: asset.type,
          name: asset.name,
          description: asset.description,
          rotationStart: asset.rotation_start,
          rotationFinish: asset.rotation_finish,
          year: asset.year,
          imdb: asset.imdb,
          imdbVoteCount: asset.imdb_vote_count,
          kinopoisk: asset.kinopoisk,
          kinopoiskVoteCount: asset.kinopoisk_vote_count,
          country: asset.country ? asset.country.name : '',
          provider: asset.provider ? asset.provider.name : '',
          studio: asset.studio ? asset.studio.name : '',
          persons: asset.persons || [],
          adult: asset.adult ? 'Yes' : 'No',
          ageLimit: asset.age_limit || 0,
          categories: asset.categories || [],
          genres: asset.genres || [],
          mpaa: asset.mpaa || '',
          vastId: asset.vast_id || '',
          durationMin: Math.round((asset.duration || 0)/60),
          duration: moment.utc((asset.duration || 0) * 1000).format('HH:mm:ss'),
          poster: {
            state: '',
            url: '',
            source: ''
          },
          landscapePoster: {
            state: '',
            url: '',
            source: ''
          },
          streamResources: [],
          packages: asset.packages || [],
          streams: [],
          rotationPeriodOK: true,
          seasons: asset.series_seasons || [],
          seriesId: 0,
          seriesName: '',
          seriesStatus: '',
          seasonId: asset.episode_season_id || 0,
          seasonName: '',
          episodeIndex: asset.episode_index || 0,
          free: asset.free || false,
          conditions: {
              ready: processCondition({})
          }
        };

        for (var i = 0; i < processed.seasons.length; i++) {
            processed.seasons[i].episodes = [];
        }

        if (moment(asset.rotation_start).diff(moment()) > 0 || moment(asset.rotation_finish).diff(moment()) < 0) {
          processed.rotationPeriodOK = false;
        }

          if (asset.resources) {
              for (var i = 0; i < asset.resources.length; i++) {
                  var r = asset.resources[i]
                  if (r.type === 'picture') {
                      if (r.category === 'poster_blueprint') {
                          processed.poster.state = r.state;
                          processed.poster.url = r.url;
                          processed.poster.source = r.source;
                      }
                      if (r.category === 'landscape') {
                          processed.landscapePoster.state = r.state;
                          processed.landscapePoster.url = r.url;
                          processed.landscapePoster.source = r.source;
                      }
                      continue
                  }
                  var pr = {
                      id: r.id,
                      type: r.type.toUpperCase(),
                      state: r.state,
                      deployer: r.deployer,
                      preparer: r.preparer,
                      added: r.create_time,
                      private: r.private || false,
                      URL: r.source,
                      category: r.category,
                      tags: '',
                      depth: parseInt(r.catchup_depth) || 0
                  }
                  if (r.deployer_args && r.deployer_args.cdn_tag) {
                      pr.tags = r.deployer_args.cdn_tag;
                  }
                  if (r.type === 'dash' || r.type === 'hls' || r.type === 'hls-protected' || r.type === 'dash-protected') {
                      processed.streams.push(pr)
                  }
                  processed.streamResources.push(pr)
              }
          }

        if (asset.conditions) {
          var ready = asset.conditions.filter(function(c) {
            if (c.type === 'ready') return c;
          });
          if (ready.length) {
            processed.conditions.ready = processCondition(ready[0]);
          }
        }

        return processed;
      };

      var processCondition = function (condition) {
          return {
              id: condition.id || 0,
              required: condition.required || false,
              type: condition.type || '',
              state: condition.state || ''
          }
      };

      var getTotal = function(params) {
        if (params === undefined) {
          params = {};
          var types = [];
          if ($scope.filters.type.movie) types.push('movie');
          if ($scope.filters.type.series) types.push('series');
          if ($scope.filters.type.episode) types.push('episode');
          params['type[in]'] = types.join(',');
        }

        if (params.hasOwnProperty('$match') && params['$match'] !== '') {
            AssetResource.get(params).$promise
                .then(function (assets) {
                    $scope.total = assets.length;
                })
                .catch(function (reason) {
                    $rootScope.debugInfo(reason, 'silent');
                })
        } else {
            AssetResource.count(params).$promise
                .then(function (response) {
                    $scope.total = response.data ? response.data : 0;
                })
                .catch(function (reason) {
                    $rootScope.debugInfo(reason);
                });
        }
      };

      getTotal();

      $scope.getAssets = function (silent) {
        if ($scope.loading) return;
        if (silent !== true) {
            $scope.loading = true;
            $rootScope.showLinearProgress('#vodCollectionLoader');
        }

        var params = {};
        var types = [];
        if ($scope.filters.type.movie) types.push('movie');
        if ($scope.filters.type.series) types.push('series');
        if ($scope.filters.type.episode) types.push('episode');
        params['type[in]'] = types.join(',');

        if ($scope.filters.name.trim() !== '') {
/*            var searchByName = '';
            var parts = $scope.filters.name.split(' ');
            for (var i = 0; i < parts.length; i++) {
                if (parts[i].trim() !== '') {
                    searchByName += parts[i].trim() + "* "
                }
            }
            if (searchByName) {
                params['$match'] = searchByName;
            }*/
            params['$match'] = $scope.filters.name.trim();
        }

        if ($scope.filters.genres.length > 0) {
            var ids = [];
            for (var i = 0; i < $scope.filters.genres.length; i++) {
                ids.push($scope.filters.genres[i].id);
            }
            params['genres.id[in]'] = ids.join(',');
        }

        if ($scope.filters.categories.length > 0) {
            var ids = [];
            for (var i = 0; i < $scope.filters.categories.length; i++) {
                ids.push($scope.filters.categories[i].id);
            }
            params['categories.id[in]'] = ids.join(',');
        }

        if ($scope.filters.packages.length > 0) {
            var ids = [];
            for (var i = 0; i < $scope.filters.packages.length; i++) {
                ids.push($scope.filters.packages[i].id);
            }
            params['packages.id[in]'] = ids.join(',');
        }

        getTotal(params);

        params['$limit'] = $scope.limit;
        params['$offset'] = $scope.offset;
        params['$expand'] = 'resources(url),categories,genres,packages,provider,persons,country,studio,series_seasons,conditions';
        params['$orderby'] =  _.get($scope.collectionData.sortBy, 'field', '');

        AssetResource.get(params).$promise
            .then(function (assets) {
              if (assets.length === 0 && $scope.routePage != 1) {
                  $scope.routePage = 1;
                  $scope.offset = 0;
                  $scope.loading = false;
                  $location.search('page', $scope.routePage);
              } else {
                  var processed = [];
                  for (var i = 0; i < assets.length; i++) {
                      var asset = assets[i];
                      processed.push(processAsset(asset));
                  }
                  $scope.assets = processed;
                  $scope.loading = false;
              }
              $rootScope.hideLinearProgress('#vodCollectionLoader');
            })
            .catch(function (reason) {
              $scope.loading = false;
              $rootScope.hideLinearProgress('#vodCollectionLoader');
              if (silent !== true) {
                  ToastService.Small({
                      title: 'Sorry, some services are unavailable right now. If you\'re still having problems, try reloading the page',
                      color: 'amber',
                      icon: 'server-off',
                      blocked: true
                  }, 1000 * 3);
              }
              $rootScope.debugInfo(reason, 'silent');
            })
      };

      $scope.filter = function(keyEvent) {
/*        if (keyEvent && keyEvent.which !== 13) {
            return;
        }*/
        $scope.offset = 0;
        if ($scope.routePage === 1) {
          $scope.getAssets();
        } else {
          $scope.routePage = 1;
          $location.search('page', $scope.routePage);
        }
      };

      $scope.nextPage = function () {
        if ($scope.offset + $scope.limit < $scope.total) {
          $scope.offset = $scope.offset + $scope.limit;
          $scope.routePage = Number($scope.routePage) + 1;
          $location.search('page', $scope.routePage);
        }
      };

      $scope.prevPage = function () {
        if ($scope.offset - $scope.limit >= 0) {
          $scope.offset = $scope.offset - $scope.limit;
          $scope.routePage = Number($scope.routePage) - 1;
        } else {
          $scope.offset = 0;
          $scope.routePage = 1;
        }
        $location.search('page', $scope.routePage);
      };


      $scope.clearSelectedVOD = function () {
        $scope.selectedVOD = {};
        $scope.selectedResource = {
              id: 0,
              loading: false,
              url: '',
              urlEsc: '',
              error: '',
              subscriber: {},
        }
        $location.search('asset_id', null);
      };

      $scope.isAssetSelected = function () {
        return !_.isEmpty($scope.selectedVOD);
      };

      $scope.selectVOD = function(asset) {
          $location.search('asset_id', asset.id);
      };

      $scope.selectAsset = function (asset, silent) {
        if (!asset.type) {
            if (silent !== true) {
                $scope.selectedVOD = {};
            }
            var selectedParams = {};
            if (silent !== true) {
                $scope.loading = true;
                $rootScope.showLinearProgress('#vodCollectionLoader');
            }
            selectedParams['id[eq]'] = asset.id;
            selectedParams['type[in]'] = 'movie,series,episode';
            selectedParams['$expand'] = 'resources(url),categories,genres,packages,provider,persons,country,studio,series_seasons,conditions';
            AssetResource.get(selectedParams).$promise
                .then(function (result) {
                    if (result.length) {
                        $scope.selectAsset(processAsset(result[0]), silent);
                    } else {
                        $location.search('asset_id', null);
                        $scope.loading = false;
                        $rootScope.hideLinearProgress('#vodCollectionLoader');
                    }
                })
                .catch(function (reason) {
                    $location.search('asset_id', null);
                    $scope.loading = false;
                    $rootScope.hideLinearProgress('#vodCollectionLoader');
                    $rootScope.debugInfo(reason, 'silent');
                });
            return;
        }

        $scope.selectedVOD = asset;
        if (silent !== true) {
            $scope.loading = true;
            $rootScope.showLinearProgress('#vodCollectionLoader');
        }

        if (asset.streams.length > 0) {
           $scope.selectedResource.id = asset.streams[0].id + ''
        }

        var ids = [];
        ids.push(asset.id);
        for (var i = 0; i < asset.packages.length; i++) {
            ids.push(asset.packages[i].id);
        }

        $scope.selectedVOD.purchaseOptions = {};
        $scope.selectedVOD.packagePurchaseOptions = [];

        AssetService.GetAssetInId(ids)
          .then(function (assets) {
            for (var i = 0; i < assets.length; i++) {
                var a = assets[i];
                var purchaseOptions = {
                    package: a.title,
                    free: false,
                    plans: []
                };
                for (var j = 0; j < a.offers.length; j++) {
                    var offer = a.offers[j];
                    if (offer.type === 'free') {
                        purchaseOptions.free = true;
                    } else {
                        purchaseOptions.plans.push(offer.name);
                    }
                }
                if (a.id === asset.id) {
                    if (asset.free) purchaseOptions.free = true;
                    $scope.selectedVOD.purchaseOptions = purchaseOptions;
                } else {
                    $scope.selectedVOD.packagePurchaseOptions.push(purchaseOptions);
                }
            }
            $scope.loading = false;
            $rootScope.hideLinearProgress('#vodCollectionLoader');
          })
          .catch(function (reason) {
            $rootScope.debugInfo(reason, 'silent');
            $scope.loading = false;
            $rootScope.hideLinearProgress('#vodCollectionLoader');
          });


          ids = [];
          for (var i = 0; i < asset.packages.length; i++) {
              ids.push(asset.packages[i].id);
          }
          if (ids.length) {
              var params = {};
              params['id[in]'] = ids.join(',');
              params['$expand'] = 'groups';
              AssetResource.get(params).$promise
                  .then(function (assets) {
                      var groups = {};
                      for (var i = 0; i < assets.length; i++) {
                          var asset = assets[i];
                          if (asset.groups) {
                              for (var j = 0; j < asset.groups.length; j++) {
                                  if (!groups.hasOwnProperty(asset.groups[j].name)) {
                                      groups[asset.groups[j].name] = {
                                          group: asset.groups[j].name,
                                          packages: {}
                                      }
                                  }
                                  groups[asset.groups[j].name].packages[asset.name] = true;
                              }
                          }
                      }
                      $scope.selectedVOD.groups = [];
                      for (var groupName in groups) {
                          if (!groups.hasOwnProperty(groupName)) {
                              continue
                          }
                          var packages = [];
                          for (var packageName in groups[groupName].packages) {
                              if (!groups[groupName].packages.hasOwnProperty(packageName)) {
                                  continue
                              }
                              packages.push(packageName);
                          }
                          $scope.selectedVOD.groups.push({
                              name: groupName,
                              packages: packages
                          })
                      }
                  })
                  .catch(function (reason) {
                      $rootScope.debugInfo(reason, 'silent');
                  });
          }

          if (asset.type === 'series' && asset.seasons.length) {
              var seriesParams = {};
              var seasonIds = [];
              for (var i = 0; i < asset.seasons.length; i++) {
                  seasonIds.push(asset.seasons[i].id);
              }
              seriesParams['season.id[in]'] = seasonIds.join(',');
              seriesParams['$expand'] = 'resources(url)';
              AssetResource.get(seriesParams).$promise
                  .then(function (episodes) {
                      var seasonMap = {};
                      for (var i = 0; i < episodes.length; i++) {
                          var episode = episodes[i];
                          if (!seasonMap.hasOwnProperty(episode.episode_season_id)) {
                              seasonMap[episode.episode_season_id] = [];
                          }
                          seasonMap[episode.episode_season_id].push(episode);
                      }
                      for (var i = 0; i < $scope.selectedVOD.seasons.length; i++) {
                          if (seasonMap.hasOwnProperty($scope.selectedVOD.seasons[i].id)) {
                              $scope.selectedVOD.seasons[i].episodes = seasonMap[$scope.selectedVOD.seasons[i].id];
                          }
                      }
                  })
                  .catch(function (reason) {
                      $rootScope.debugInfo(reason, 'silent');
                  });
          }

          if (asset.type === 'episode') {
              AssetService.GetAssetById(asset.id)
                  .then(function (assets) {
                      if (assets.length) {
                          var a = assets[0];
                          if (a.tv_series_episode) {
                              AssetResource.get({'id[eq]': a.tv_series_episode.series_id, '$expand': 'series_seasons,conditions'}).$promise
                                  .then(function (series) {
                                      if (series.length) {
                                          $scope.selectedVOD.seriesId = a.tv_series_episode.series_id;
                                          $scope.selectedVOD.seriesName = series[0].name;
                                          $scope.selectedVOD.seriesStatus = '';
                                          if (series[0].conditions) {
                                              var ready = series[0].conditions.filter(function(c) {
                                                  if (c.type === 'ready') return c;
                                              });
                                              if (ready.length) {
                                                  $scope.selectedVOD.seriesStatus = processCondition(ready[0]).state;
                                              }
                                          }
                                          for (var i = 0; i < series[0].series_seasons.length; i++) {
                                              var season = series[0].series_seasons[i];
                                              if (season.id === asset.seasonId) {
                                                  if (season.season_index) {
                                                      $scope.selectedVOD.seasonName = season.season_index + '. ' + season.name;
                                                  } else {
                                                      $scope.selectedVOD.seasonName = season.name;
                                                  }
                                                  break;
                                              }
                                          }
                                      }
                                  })
                                  .catch(function (reason) {
                                      $rootScope.debugInfo(reason, 'silent');
                                  });
                          }
                      }
                  })
                  .catch(function (reason) {
                      $rootScope.debugInfo(reason, 'silent');
                  });
          }
      };

      $scope.reloadAsset = function (asset) {
        var selectedParams = {};
        selectedParams['id[eq]'] = asset.id;
        selectedParams['type[in]'] = 'movie,series,episode';
        selectedParams['$expand'] = 'resources(url),categories,genres,packages,provider,persons,country,studio,series_seasons,conditions';
        AssetResource.get(selectedParams).$promise
          .then(function (result) {
            if (result.length) {
              var processed = processAsset(result[0]);
              $scope.selectedVOD.updateTime = processed.updateTime;
              $scope.selectedVOD.poster = processed.poster;
              $scope.selectedVOD.streamResources = processed.streamResources;
              $scope.selectedVOD.streams = processed.streams;
              $scope.selectedVOD.conditions = processed.conditions;
            } else {
              $location.search('asset_id', null);
            }
          })
          .catch(function (reason) {
            $location.search('asset_id', null);
            $rootScope.debugInfo(reason, 'silent');
          });

  /*          if (asset.type === 'episode') {
                AssetService.GetAssetById(asset.id)
                    .then(function (assets) {
                        if (assets.length) {
                            var a = assets[0];
                            if (a.tv_series_episode) {
                                AssetResource.get({'id[eq]': a.tv_series_episode.series_id, '$expand': 'series_seasons,conditions'}).$promise
                                    .then(function (series) {
                                        if (series.length) {
                                            $scope.selectedVOD.seriesId = a.tv_series_episode.series_id;
                                            $scope.selectedVOD.seriesName = series[0].name;
                                            $scope.selectedVOD.seriesStatus = '';
                                            if (series[0].conditions) {
                                                var ready = series[0].conditions.filter(function(c) {
                                                    if (c.type === 'ready') return c;
                                                });
                                                if (ready.length) {
                                                    $scope.selectedVOD.seriesStatus = processCondition(ready[0]).state;
                                                }
                                            }
                                            for (var i = 0; i < series[0].series_seasons.length; i++) {
                                                var season = series[0].series_seasons[i];
                                                if (season.id === asset.seasonId) {
                                                    $scope.selectedVOD.seasonName = season.season_index + '. ' + season.name;
                                                    break;
                                                }
                                            }
                                        }
                                    })
                                    .catch(function (reason) {
                                        $rootScope.debugInfo(reason, 'silent');
                                    });
                            }
                        }
                    })
                    .catch(function () {
                        $rootScope.debugInfo(reason, 'silent');
                    });
            }*/
        };
      /////////////

      $rootScope.EVENTS = _.extend($rootScope.EVENTS, { UPDATE_VOD_COLLECTION: 'update.vod.collection' });
      $scope.permissions = $rootScope.permissions;

      $scope.collection = [];
      $scope.loading = false;
      $scope.importInProgress = false;

      ////
/*      $scope.categories = [
        { title: 'Movies' },
        { title: 'Series' },
        { title: 'Cartoons' }
      ];*/

      ///

      $scope.parseAsset = function (asset) {
        asset._PrivateData = {};

        asset.type = $scope.getAssetType(asset);
        asset._rotation_start = new Date(asset.rotation_start*1000);
        asset._rotation_end = new Date(asset.rotation_finish*1000);

        asset.resources.forEach(function (resource) {

          if (resource.type === 'stream' && resource.stream_type.indexOf('youtube') !== -1) {
            asset._has_youtube = true;
            resource.stream_type = 'youtube';
            resource._stream_sub_type = 'y';
          }
        });

        return asset;
      };

      var deepSearch = function (search, collection) {
        if (!collection) {
          collection = $scope.collection;
        }

        var foundEpisode;
        var foundEpisodeIndex;

        for (var i = 0; i < collection.length; i++) {
          var item = collection[i];

          if (item.type === 'tv_series' && _.size(item._Seasons)) {

            for (var j = 0; j < item._Seasons.length; j++) {
              var season = item._Seasons[j];

              if (_.size(season.episodes)) {
                foundEpisodeIndex = _.findIndex(season.episodes, { id: search.id });

                if (foundEpisodeIndex !== -1) {

                  if (search.season.oldIndex !== search.season.newIndex) {
                    foundEpisode = _.pullAt(season.episodes, [foundEpisodeIndex])[0];
                  } else {
                    foundEpisode = season.episodes[foundEpisodeIndex];
                  }

                  break;
                }
              }
            }
          }

          if (foundEpisode && search.season.oldIndex !== search.season.newIndex) {
            var seasonPushTo = _.find(item._Seasons, { id: search.season.newIndex });

            seasonPushTo && seasonPushTo.episodes.push(foundEpisode);
            break;
          }
        }

        return foundEpisode;
      };

      $scope.getAssetType = function (asset) {

        switch (true) {
          case asset.type === 'channel' && asset.channel_type !== 'playlist':
            return 'channel';
            break;

          case asset.type === 'channel' && asset.channel_type === 'playlist':
            return 'virtual-channel';
            break;

          case asset.type === 'package' && asset.package_type === 'tv_series':
            return 'tv_series';
            break;

          case asset.type === 'movie' && !!asset.tv_series_episode:
            return 'tv_episode';
            break;

          case asset.type === 'movie':
            return 'movie';
            break;
        }

      };

      $scope._STREAM_TYPES_ATTRS = MetadataService._STREAM_TYPES_ATTRS;

      $scope.sortOptions = [
          {title: "ID Asc", field: "id"},
          {title: "ID Desc", field: "-id"},
          {title: "Name A-Z", field: "name"},
          {title: "Name Z-A", field: "-name"},
          {title: "Rental Start Asc", field: "rotation_start"},
          {title: "Rental Start Desc", field: "-rotation_start"},
          {title: "Create Time Asc", field: "create_time"},
          {title: "Create Time Desc", field: "-create_time"},
          {title: "Update Time Asc", field: "update_time"},
          {title: "Update Time Desc", field: "-update_time"},
          {title: "Year Asc", field: "year"},
          {title: "Year Desc", field: "-year"}
      ];

      $scope.collectionData = {
        empty: false,
        error: '',
        filters: {
          genres: [],
          categories: [],
          keyword: ''
        },
        sortBy: {title: "ID Desc", field: "-id"},
        offset: 0,
        limit: 20,
        isStart: false,
        isEnd: false,
/*        isEmpty: function () {
          return !$scope.loading && !$scope.collection.length;
        },*/
/*
        update: function (who) {
          if (!who.isSilentUpdate) {
            $scope.loading = true;
            $rootScope.showLinearProgress('#vodCollectionLoader');
          }

          $scope.collectionData.empty = false;
          $scope.collectionData.error = false;

          var allQ = {};

          if (ValidatorService.Numerical(who.id)) {
            allQ.byId = AssetService.GetAssetById(who.id);
          }

          if (who.id === 'all') {
            $scope.collection = [];
            this.isEnd = false;
            this.isStart = false;

            this.isStart = this.offset < this.limit;

            if ($scope.collectionData.filters.keyword ||
              $scope.collectionData.filters.genres.length ||
              $scope.collectionData.filters.categories.length) {

              allQ.allVod = AssetService.SearchByKeyword($scope.collectionData.filters.keyword, {
                genres: _.map($scope.collectionData.filters.genres, 'id'),
                categories: _.map($scope.collectionData.filters.categories, 'id'),
                view: 'vod',
                sort: _.get($scope.collectionData.sortBy, 'field', '')
              }, this.offset, this.limit + 1)
                .then(function (collection) {
                  if (collection.length < this.limit + 1) {
                    this.isEnd = true;
                  } else {
                    collection.pop();
                  }
                  return collection;
                }.bind(this));

            } else {
              allQ.allVod = AssetService.GetAllAvailableVod(this.offset, this.limit + 1, _.get($scope.collectionData.sortBy, 'field', ''))
                .then(function (collection) {
                  if (collection.length < this.limit + 1) {
                    this.isEnd = true;
                  } else {
                    collection.pop();
                  }
                  return collection;
                }.bind(this));
            }
          }

          return $q.all(allQ)
            .then(function (response) {
              $scope.loading = false;
              $rootScope.hideLinearProgress('#vodCollectionLoader');

              if (response.byId) {
                if (!response.byId.length) {
                  this.update({ id: 'all' });
                  return;
                }

                var tmpAsset = response.byId[0];

                tmpAsset = $scope.parseAsset(tmpAsset);

                var found;
                if (who.isSearch) {
                  $scope.collection = [tmpAsset];
                  this.isEnd = true;

                } else if (who.collection) {
                  console.log('Check this: ', location && location.href);

                  if (who.isEpisode) {
                    found = deepSearch(who, who.collection);

                  } else {

                    found = _.find(who.collection, { id: tmpAsset.id });
                  }
                } else {

                  if (who.isEpisode) {
                    found = deepSearch(who);

                  } else {

                    found = _.find($scope.collection, { id: tmpAsset.id });
                  }

                }

                tmpAsset._PrivateData.seasonsShow = _.get(found, '_PrivateData.seasonsShow', false);

                if (tmpAsset.type === 'tv_series') {
                  tmpAsset._Seasons = angular.copy(tmpAsset.tv_series_seasons).map(function (season, index) {
                    season.isShowen = false;
                    season._Parent = {};
                    season._Parent.id = tmpAsset.id;
                    season._Parent.seasons = tmpAsset.tv_series_seasons;
                    season._Parent.title = tmpAsset.title;
                    return season;
                  });
                }

                _.assign(found, tmpAsset);

                return $q.when(found);
              }

              if (response.allVod) {

                if (!response.allVod.length && $scope.collectionData.offset > 0) {
                  $scope.collectionData.offset = 0;
                  $scope.collectionData.limit = 20;
                  $rootScope.$broadcast($rootScope.EVENTS.UPDATE_VOD_COLLECTION, {
                    id: 'all'
                  });

                  $location.search('page', 1);

                  return;
                }

                response.allVod.forEach($scope.parseAsset);

                response.allVod
                  .filter(function (asset) {

                    return asset.type === 'tv_series';
                  })
                  .forEach(function (asset) {
                    asset._Seasons = angular.copy(asset.tv_series_seasons).map(function (season) {
                      season.isShowen = false;
                      season._Parent = {};
                      season._Parent.seasons = asset.tv_series_seasons;
                      season._Parent.title = asset.title;
                      season._Parent.id = asset.id;
                      season._Parent.index = asset.index;
                      return season;
                    });

                  });

                if (!response.allVod.length) {
                  $scope.collectionData.empty = true;
                }

                $scope.collection = response.allVod;

                if ($scope.routeVodId) {
                  var currentVodIndex = _.findIndex($scope.collection, { id: $scope.routeVodId });

                  if (currentVodIndex !== -1) {
                    $scope.openModal($scope.collection[currentVodIndex], currentVodIndex, $scope.collection, null, false);
                  } else {
                    $location.search('vod_id', null);
                  }
                }

                return $q.when($scope.collection);
              }
            }.bind(this))
            .catch(function (reason) {
              $scope.loading = false;
              $rootScope.hideLinearProgress('#vodCollectionLoader');
              ToastService.Small({
                title: 'Sorry, some services are unavailable right now. If you\'re still having problems, try reloading the page',
                color: 'amber',
                icon: 'server-off',
                blocked: true
              }, 1000 * 3);
              $rootScope.debugInfo(reason, 'silent');
              return false;
            });
        },
*/
/*        nextPage: function () {
          if (this.isEnd) return;
          $scope.routePage = $scope.routePage + 1;
          $location.search('page', $scope.routePage);
          this.offset += $scope.collectionData.limit;
          $rootScope.$broadcast($rootScope.EVENTS.UPDATE_VOD_COLLECTION, { id: 'all' });
        },
        prevPage: function () {
          if (this.isStart) return;

          if (this.offset >= this.limit) {
            this.offset -= this.limit;
            $scope.routePage = $scope.routePage - 1;
            $location.search('page', $scope.routePage);
          } else {
            this.offset = 0;
            $location.search('page', 1);
          }
          $rootScope.$broadcast($rootScope.EVENTS.UPDATE_VOD_COLLECTION, { id: 'all' });
        }*/
      };

      var sortBy = window.localStorage['vod_sortby'];
      if (sortBy && sortBy !== 'undefined') {
          try {
              $scope.collectionData.sortBy = JSON.parse(sortBy);
          } catch (e) {
          }
      }


/*      $scope.applyFilters = function (filters) {
        if ($scope.loading || _.isEmpty(filters)) return;

        if (filters.keyword ||
          filters.genres.length ||
          filters.categories.length) {
          $scope.collectionData.offset = 0;
        }

        if (ValidatorService.Numerical(filters.keyword)) {
          $rootScope.$broadcast($rootScope.EVENTS.UPDATE_VOD_COLLECTION, {
            id: filters.keyword,
            isSearch: true
          });
        } else {
          $rootScope.$broadcast($rootScope.EVENTS.UPDATE_VOD_COLLECTION, { id: 'all' })
        }
      };*/

/*      $scope.showSeasons = function (asset, event) {
        if (event && event.stopPropagation) event.stopPropagation();
        if (event && event.preventDefault) event.preventDefault();

        asset._PrivateData.seasonsShow = !asset._PrivateData.seasonsShow
      };*/

      $scope.deleteAsset = function (asset, event, isSubAsset) {
        if (event && event.stopPropagation) event.stopPropagation();
        if (event && event.preventDefault) event.preventDefault();

        $scope.modalWindowScope = $scope.$new();
        var inner = '<span class="heavy">Are you sure you want <b>to delete</b> the ' + asset.type + ' "' + asset.name +'"?</span>';

        ModalWindowService.Open({
          content: inner,
          actions: [
            {
              title: 'I understand. Do it',
              color: 'green',
              fn: function () {
                AssetResource.remove({id: asset.id}).$promise
                  .then(function () {
                    $scope.loading = false;
                    $rootScope.hideLinearProgress('#vodCollectionLoader');
                    ToastService.Small({
                      title: 'VOD: <b class="tc-white"> ' + asset.name + '</b> successfully deleted',
                      color: 'green',
                      icon: 'delete'
                    },1000 * 3);
                    if (isSubAsset === true) {
                        if (asset.type === 'season') {
                            for (var i = 0; i < $scope.selectedVOD.seasons.length; i++) {
                                if (asset.id === $scope.selectedVOD.seasons[i].id) {
                                    $scope.selectedVOD.seasons.splice(i, 1);
                                    break;
                                }
                            }
                            AssetResource.update({id: $scope.selectedVOD.id}, { name: $scope.selectedVOD.name }).$promise
                                .then(function (response) {
                                })
                                .catch(function (reason) {
                                });
                        }
                        if (asset.type === 'episode') {
                            for (var i = 0; i < $scope.selectedVOD.seasons.length; i++) {
                                for (var j = 0; j < $scope.selectedVOD.seasons[i].episodes.length; j++) {
                                    if (asset.id === $scope.selectedVOD.seasons[i].episodes[j].id) {
                                        $scope.selectedVOD.seasons[i].episodes.splice(j, 1);
                                        break;
                                    }
                                }
                            }
                        }
                    } else {
                        $scope.getAssets();
                        if ($routeParams.asset_id) {
                            $scope.clearSelectedVOD();
                        }
                    }
                  })
                  .catch(function (reason) {
                    $scope.loading = false;
                    $rootScope.hideLinearProgress('#vodCollectionLoader');
                    $rootScope.debugInfo(reason);
                    ToastService.Small({
                      title: 'VOD: <b class="tc-white"> ' + asset.name + '</b> delete failed',
                      color: 'red',
                      icon: 'delete'
                    },1000 * 3);
                  });
              }
            },
            {
              title: 'cancel',
              color: 'red',
              fn: function () {}
            }
          ],
          onComplete: function () {
            $scope.modalWindowScope.$destroy();
          }
        });
      };

      //When modal window open = save Data for edit
      $scope.openModal = function (asset, e, isNewType, id) {
        if (e && e.preventDefault) e.preventDefault();
        if (e && e.stopPropagation) e.stopPropagation();

        var modalScope = $rootScope.$new();

        if (isNewType) {
          modalScope.asset = {type: isNewType};
          if (isNewType === 'season') {
              modalScope.asset.seriesId = asset.id;
              if (id > 0) {
                  modalScope.asset.id = id;
              }
          }
          if (isNewType === 'episode') {
              modalScope.asset.seriesId = asset.id;
              modalScope.asset.seriesName = asset.name;
              if (id > 0) {
                  modalScope.asset.id = id;
              }
            }
        } else {
          modalScope.asset = angular.copy(asset);
        }

        modalScope.loading = false;

        modalScope.processAsset = function (asset) {
          if (modalScope.loading) return;

          if (isNewType && !id) {
            modalScope.createFn();
          } else {
            modalScope.updateFn(asset);
          }
        };

        modalScope.close = function (id) {
          if (modalScope.loading) return;

          modalScope.fullscreenToogle(false);
          ModalWindowService.Close($scope.window, false);
          if (id === -1) {
              AssetResource.update({id: asset.id}, { name: asset.name }).$promise
                  .then(function (response) {
                      $scope.selectAsset({id: asset.id});
                  })
                  .catch(function (reason) {
                  });
              return;
          }
          if (id) {
            if ($routeParams.asset_id == id) {
                $scope.selectAsset({id: id});
            } else {
                $location.search('asset_id', id);
            }
          }
        };

        modalScope.fullscreenToogle = function (state) {
          if (typeof state !== 'undefined') {
            modalScope.fullscreen = state;
          } else {
            modalScope.fullscreen = !modalScope.fullscreen;
          }

          ModalWindowService.Fullscreen($scope.window, state);
        };

        modalScope._modalWindow_ = $templateCache.get('lm-asset-edit/edit-window.tpl.html');

        modalScope._modalWindow_ = $compile(modalScope._modalWindow_)(modalScope);

        $scope.window = ModalWindowService.Open({
          content: modalScope._modalWindow_,
          navigation: $compile($templateCache.get('lm-asset-edit/navigation-buttons.tpl.html'))(modalScope),
          clear: true,
          keyboard: true,
          size: {
            s: 11,
            l: 10
          }
        });

        modalScope._modalWindow_.on('$destroy', function () {
          modalScope.$destroy();
        })
      };

      $scope.createEpisode = function (parent, index) {
        var episode = {};
        episode._PrivateData = {};
        episode._PrivateData.seasonIndexNew = index + 1;
        episode._Parent = {};
        episode._Parent.seasons = parent.tv_series_seasons;
        episode._Parent.title = parent.title;
        episode._Parent.id = parent.id;
        episode.tv_series_episode = {
          season_id: parent.tv_series_seasons[index].id,
          season_index: index + 1
        };

        return episode;
      };

      $scope.importPerform = function () {

        $timeout(function () {
          angular.element('#import_xml').trigger('click');
        });
      };

      $timeout(function () {
        angular.element('#import_xml')
          .on('change', function () {
            $scope._progress_ = angular.element('#importProgress');
            $scope._bar_ = $scope._progress_.find('.determinate');

            $scope.error = '';
            if (!this.files || !this.files.length) {
              ToastService.Small({
                title: 'Please, choose at least one file',
                color: 'red',
                icon: 'arrow-down-bold-hexagon-outline'
              }, 1000 * 60);

              return;
            }

            var file = this.files[0];

            if (file.type !== 'text/xml') {
              ToastService.Small({
                title: 'File should be in XML format',
                color: 'red',
                icon: 'arrow-down-bold-hexagon-outline'
              }, 1000 * 60);

              return;
            }

            $scope.importInProgress = true;
            $scope._progress_.css({ 'display': 'block' });

            angular.element('#import_xml').innerHTML =  angular.element('#import_xml').innerHTML;

            ImportService.UploadToCloud(file, $scope._progress_)
              .then(function (response) {
                $scope._progress_.css({ 'display': 'none' });
                $scope._bar_.css({ width: 0 });

                ImportService.CreatePerformImport(response.Location)
                  .then(function () {
                    $scope.importInProgress = false;

                    ToastService.Big({
                      title: 'Import will continue in background. Check this page later.',
                      color: 'green',
                      icon: 'arrow-down-bold-hexagon-outline'
                    }, 1000 * 60);
                  })
                  .catch(function (reason) {
                    $rootScope.debugInfo(reason);
                  });
              }, function (reason) {
                $scope.importInProgress = false;
                $scope._progress_.css({ 'display': 'none' });
                $scope._bar_.css({ width: 0 });

                $rootScope.debugInfo(reason);
              });
          });
      }, 600);

      // Stream Check
        var searchTimeout;
        $scope.findSubscriber = function(text) {
            if (!text) return;
            text = text.trim();
            if (text === '') return;
            if (searchTimeout) $timeout.cancel(searchTimeout);
            $scope.findSubscriberLoading = true;
            searchTimeout = $timeout(function () {
                var params = {};
                params['$limit'] = 1000;
                params['$match'] = text
                SubscriberResource.get(params).$promise
                    .then(function (result) {
                        var users = (result.data || []);
                        var userList = [];
                        for (var i = 0; i < users.length; i++) {
                            const subscriber = users[i];
                            userList.push({
                                id: subscriber.id,
                                title: subscriber.username,
                            });
                        }
                        $scope.subscribers = userList;
                        $scope.findSubscriberLoading = false;
                    })
                     .catch(function (reason) {
                        $rootScope.debugInfo(reason, 'silent');
                    })
            }, 650);
        };

        $scope.getSubscriberStreamURL = function(subscriber) {
            $scope.selectedResource.loading = true;
            $scope.selectedResource.subscriber = subscriber;
            $scope.refreshURL();
        };

        $scope.copyURL = function() {
            var url = '';
            if ($scope.selectedResource.type === 'hls') {
                url = $rootScope.getHLSPlayerURL($scope.selectedResource.urlEsc);

            } else if ($scope.selectedResource.type === 'hls-protected') {
                url = 'https://vtb.axinom.com/fairplay_streaming_sample_player.html?url=' + $scope.selectedResource.urlEsc + '&license=' + $scope.selectedResource.fpsLicenseURL + '&token=&certUrl=' + $scope.selectedResource.fpsCertURL;
            }
            if ($scope.selectedResource.type === 'dash' || $scope.selectedResource.type === 'dash-protected') {
                url = 'https://shaka-player-demo.appspot.com/demo/#asset=' + $scope.selectedResource.url + ';license=' + $scope.selectedResource.wvLicenseURL;
            }
            $scope.copy(url)
        }

        $scope.copy = function(value) {
            const tempInput = document.createElement('input')
            tempInput.style = 'position: absolute; left: -1000px; top: -1000px'
            tempInput.value = value
            document.body.appendChild(tempInput)
            tempInput.select()
            document.execCommand('copy')
            document.body.removeChild(tempInput)
        }

      $scope.refreshURL = function() {
          if (!$scope.selectedResource.subscriber.title) {
              return
          }
          $scope.selectedResource.loading = true;

          for (var i = 0; i < $scope.selectedVOD.streams.length; i++) {
              if ($scope.selectedVOD.streams[i].id == $scope.selectedResource.id) {
                  $scope.selectedResource.type = $scope.selectedVOD.streams[i].type.toLowerCase();
                  break;
              }
          }

          var clientId = '';
          for (var i=0; i < $rootScope._self.services.length; i++) {
              var service = $rootScope._self.services[i];
              if (service.instance && service.instance.platform && service.instance.platform.client_id) {
                  clientId = service.instance.platform.client_id;
                  break;
              }
          }
          if (clientId === '') {
              return;
          }

          return SubscriberV2Service.GetUserDeviceToken($scope.selectedResource.subscriber.title, clientId)
              .then(function (result) {
                  if (result.data) {
                      var token = result.data;

                      if ($scope.selectedResource.type === 'hls-protected' || $scope.selectedResource.type === 'dash-protected' || $scope.selectedResource.type === 'dash') {
                          AssetV2Service.GetProtectedStream($scope.selectedVOD.id, $scope.selectedResource.id, token)
                              .then(function (response) {
                                  var streamInfo = response.data;
                                  $scope.selectedResource.url = streamInfo.playback_url;
                                  $scope.selectedResource.urlEsc = escape(streamInfo.playback_url);
                                  $scope.selectedResource.loading = false;
                                  $scope.selectedResource.error = '';
                                  $scope.selectedResource.wvLicenseURL = streamInfo.wv_license_url;
                                  $scope.selectedResource.fpsLicenseURL = escape(streamInfo.fps_license_url);
                                  $scope.selectedResource.fpsCertURL = escape(streamInfo.fps_cert_url);
                              })
                              .catch(function (reason) {
                                  $scope.selectedResource.loading = false;
                                  if (reason.data.error) {
                                      $scope.selectedResource.error = reason.data.error.message;
                                  }
                                  $scope.selectedResource.url = '';
                                  $scope.selectedResource.urlEsc = '';
                                  $rootScope.debugInfo(reason, 'silent');
                              })
                      } else {
                          AssetV2Service.GetStream($scope.selectedVOD.id, $scope.selectedResource.id, token)
                              .then(function (response) {
                                  var streamURL = response.data;
                                  $scope.selectedResource.url = streamURL;
                                  $scope.selectedResource.urlEsc = escape(streamURL);
                                  $scope.selectedResource.loading = false;
                                  $scope.selectedResource.error = '';
                              })
                              .catch(function (reason) {
                                  $scope.selectedResource.loading = false;
                                  if (reason.data.error) {
                                      $scope.selectedResource.error = reason.data.error.message;
                                  }
                                  $scope.selectedResource.url = '';
                                  $scope.selectedResource.urlEsc = '';
                                  $rootScope.debugInfo(reason, 'silent');
                              })
                      }
                  } else {
                      $scope.selectedResource.loading = false;
                  }
              })
              .catch(function (reason) {
                  $scope.selectedResource.loading = false;
                  $rootScope.debugInfo(reason, 'silent');
              });
      };


/*
      $scope.broadcastListener = $rootScope.$on($rootScope.EVENTS.UPDATE_VOD_COLLECTION, function (event, data) {
        $scope.collectionData.update(data);
      });
*/

      /**
       * Init collection on controller add
       */
      $scope.routePage = 1;
      if (!_.isUndefined($routeParams.page) && $routeParams.page > 0) {
        $scope.routePage = Number($routeParams.page);
       // $scope.collectionData.offset = ($scope.routePage - 1) * $scope.collectionData.limit;
        //$scope.collectionData.limit = 20;

        $scope.offset = ($scope.routePage - 1) * $scope.limit;
        //$scope.offset = offset + $scope.limit >= $scope.total ? 0 : offset;
        //$scope.getAssets();
        $scope.getAssets();
      } else {
        $location.search('page', 1);
      }

        $scope.routeAssetId = null;
        if ($routeParams.asset_id) {
            $scope.routeAssetId = Number($routeParams.asset_id);
            $scope.selectAsset({id: $scope.routeAssetId})
        } else {
            $location.search('asset_id', null);
        }

/*      //$scope.routeVodId = null;
      if (!_.isUndefined($routeParams.asset_id)) {
        $scope.routeVodId = Number($routeParams.vod_id);
      } else {
        $location.search('vod_id', null);
      }*/

      $scope.routeKeyword = '';
      if (!_.isUndefined($routeParams.keyword)) {
        $scope.routeKeyword = $routeParams.keyword;
        $scope.collectionData.filters.keyword = $routeParams.keyword;
      } else {
        $location.search('keyword', null);
      }

      ///
      $scope.watcherFiler = $scope.$watchCollection('collectionData.filters', function (newValue, oldValue) {
        if (oldValue && newValue) {

/*          //TODO: Check this logic
          if (!newValue.keyword && !newValue.genres.length && !newValue.categories.length
            && (oldValue.keyword || oldValue.genres.length || oldValue.categories.length)) {
            $scope.collectionData.offset = 0;
            $location.search('page', 1);
            $scope.applyFilters(newValue);
            $location.search('keyword', null);
          }

          //if (!oldValue.keyword && !oldValue.genres.length && !oldValue.categories.length) {
          //  $scope.collectionData.offset = 0;
          //}

          if (newValue.keyword || newValue.genres.length || newValue.categories.length) {
            $location.search('page', 1);
            if (newValue.keyword) $location.search('keyword', newValue.keyword);
            $scope.applyFilters(newValue);
          }*/
        }
      });

      ////
      $scope.sortWatcher = $scope.$watchCollection('collectionData.sortBy', function (newValue, oldValue) {
        if (oldValue && newValue) {
          if (newValue.title !== oldValue.title) {
              $scope.getAssets();
              window.localStorage['vod_sortby'] = JSON.stringify($scope.collectionData.sortBy);
              //$scope.collectionData.offset = 0;
              // $location.search('page', 1);
              //$rootScope.$broadcast($rootScope.EVENTS.UPDATE_VOD_COLLECTION, { id: 'all' })
          }
        }
      });

      /////
      $scope.$on('$routeUpdate', function () {
          //console.log("$routeUpdate");
          //console.log("$routeParams.page", $routeParams.page);
          //console.log("$scope.routePage", $scope.routePage);
          //console.log("$scope.routeAssetId", $scope.routeAssetId);
          //console.log("$routeParams.asset_id", $routeParams.asset_id);

        $scope.routePage = $routeParams.page || 1;

        if ($scope.routeAssetId && !$routeParams.asset_id) {
          ModalWindowService.Close($scope.window, false);
        }

        $scope.routeAssetId = Number($routeParams.asset_id) || null;
        if ($scope.routeAssetId) {
            $scope.selectAsset({id: $scope.routeAssetId})
        } else {
            $scope.clearSelectedVOD()
        }

        $scope.getAssets();


          /*        if ($scope.routeKeyword && !$routeParams.keyword) {
                    $scope.collectionData.filters.keyword = '';
                    $scope.routeKeyword = '';
                    $rootScope.$broadcast($rootScope.EVENTS.UPDATE_VOD_COLLECTION, { id: 'all' });
                  }
                  $scope.routeKeyword = $routeParams.keyword || '';*/
      });

     // $scope.applyFilters($scope.collectionData.filters);

      $scope.updateIntreval = $interval(function () {
          $scope.routeAssetId = Number($routeParams.asset_id) || null;
          if ($scope.routeAssetId) {
              var silent = false;
              if ($scope.isAssetSelected()) {
                  silent = true;
              }
              $scope.reloadAsset({id: $scope.routeAssetId})
          } else {
              $scope.clearSelectedVOD();
              $scope.getAssets(true);
          }
      }, 15 * 1000);

      $scope.$on('$destroy', function () {
        $scope.watcherFiler();
        $scope.sortWatcher();
        $interval.cancel($scope.updateIntreval);
        //$scope.broadcastListener();

        angular.element('#import_xml').off('change');
      });

    }]);
